import type { LocaleResolverContext } from '#src/shared/routes';

import { extractTopicLocaleFromSlug } from '#src/app/shared/utils/topic';

/**
 * Topic slugs encode their intended language as a suffix (e.g. `裏金-ja-jp`). For bots
 * (e.g. Googlebot, which crawls as en-US), we override the request locale with the
 * topic's locale so the SEO meta tags — title and description — are generated in the
 * topic's language instead of English. Real users keep their own locale.
 *
 * Returns `undefined` (no override) for non-bots and for slugs without a valid locale
 * suffix, in which case the user's l10n is used.
 */
export async function resolveTopicL10nForBotsFromSlugParam({
	params: { slug },
	isBot,
}: LocaleResolverContext): Promise<{ locale?: string; countryCode?: string } | undefined> {
	if (!isBot() || !slug) return undefined;

	const locale = extractTopicLocaleFromSlug(slug);
	return locale ? { locale } : undefined;
}
